import { useState } from "react";

import { Button, Modal, Table } from "react-bootstrap";

import PublicationItemModal from "./publication-item-modal";

type PublicationTableProps = {
  id: number;
  title: string;
  source: string;
  studies: string[];
  year: number;
};

export default function PublicationsTable({
  data,
  count,
}: {
  data: { results: PublicationTableProps[] } | undefined;
  count: number;
}) {
  const headers = ["TITLE", "SOURCE", "SURVEY", "YEAR"];

  const [showItemModal, setShowItemModal] = useState(false);
  const [itemId, setItemId] = useState<number>();

  const handleItemClick = (itemId: number) => {
    setItemId(itemId);
    setShowItemModal(true);
  };
  return (
    <>
      <Table striped responsive className="mt-4">
        <thead>
          <tr className="text-start g2-table-header-blue">
            {headers.map((item: string, index: number) => (
              <th key={index}>{item}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {count > 0 && data?.results ? (
            data.results.map((item, index) => (
              <tr key={index} className="align-middle">
                <td className="g2-link-blue" onClick={() => handleItemClick(item.id)}>
                  {item.title.length > 85 ? `${item.title.substring(0, 85)}...` : item.title}
                </td>
                <td>{item.source}</td>
                <td>
                  {item.studies.map((surveyItem, idx) => (
                    <span key={idx} className="g2-label sm">
                      {surveyItem}
                    </span>
                  ))}
                </td>
                <td>{item.year}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={4} className="text-center fst-italic">
                No results found.
              </td>
            </tr>
          )}
        </tbody>
      </Table>

      <Modal show={showItemModal} onHide={() => setShowItemModal(false)} size="xl" aria-labelledby="pub-item-modal">
        <Modal.Header closeButton>
          <Modal.Title className="g2-text-grey">
            <h1 className="modal-title fs-5">
              <i className="bi bi-list-columns-reverse me-2"></i>Details
            </h1>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>{itemId && <PublicationItemModal itemId={itemId} />}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowItemModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
